import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';
import { RouteConfig } from 'vue-router';

const ticketManagement: RouteConfig = {
  path: '/workTicketManagement',
  name: 'workticketmanagement',
  meta: {
    title: 'Work Ticket Management',
    icon: 'Work Ticket Management',
  },
  redirect: '/workTicketManagement/workTicketManagement',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'workTicketManagement',
      name: 'workticketmanagement.workticketmanagement',
      meta: {
        title: 'Work Ticket Management',
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import('@/react-app/pages/work-ticket-management/list-page/index')
          ),
      },
    },
    {
      path: 'workTicketManagement/detail/:id',
      name: 'workticketmanagement.workticketmanagement.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement.detail',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/detail-page/index'
              )
          ),
      },
    },
    {
      path: 'workTicketManagement/handle/:id',
      name: 'workticketmanagement.workticketmanagement.handle',
      meta: {
        title: 'Handle',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement.handle',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/detail-page/index'
              )
          ),
      },
    },
  ],
};
export default ticketManagement;
